'use client';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import Background from '@/components/shared/components/background';
import ZhkLogo from '@/components/shared/components/logo';
import { LOGO_SIZE } from '@/components/shared/components/logo/type';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { error: errorLocalization, layout: layoutLocalization } = pageLevelLocalization;

export default function Error() {
  const router = useRouter();

  // Hide header and footer for 500 error page
  useEffect(() => {
    // Hide all headers and footers
    const headers = document.querySelectorAll('header');
    const footers = document.querySelectorAll('footer');

    headers.forEach((header) => {
      header.style.display = 'none';
      header.classList.add('hidden');
    });

    footers.forEach((footer) => {
      footer.style.display = 'none';
      footer.classList.add('hidden');
    });

    // Also hide any navigation elements
    const navs = document.querySelectorAll('nav');
    navs.forEach((nav) => {
      nav.style.display = 'none';
      nav.classList.add('hidden');
    });

    return () => {
      headers.forEach((header) => {
        header.style.display = '';
        header.classList.remove('hidden');
      });

      footers.forEach((footer) => {
        footer.style.display = '';
        footer.classList.remove('hidden');
      });

      navs.forEach((nav) => {
        nav.style.display = '';
        nav.classList.remove('hidden');
      });
    };
  }, []);

  return (
    <div className='no-scrollbar! fixed inset-0 z-[9999] bg-white'>
      <Container
        center
        className='error-page-bg-mobile h-screen w-screen flex-col gap-2 text-[#1F2025]'
      >
        <Background
          src={imagesList.images.error500}
          className='z-10 m-auto mt-[25vh] h-[330px]! w-[600px]!  object-contain md:object-cover '
        />
        <Container center className='z-20 flex-col'>
          <ZhkLogo darkMode size={LOGO_SIZE.XL} />
          <Heading type={HEADING_TYPE.H1} className='mt-7 text-3xl font-bold'>
            {errorLocalization.message500}
          </Heading>
          <Text className='mb-[18px] text-[#424244]' size={SIZE_ENUM.SM}>
            {layoutLocalization.bestPluginAndThemeProvider}
          </Text>
          <Button
            className='h-[55px] w-[186px] rounded-lg bg-[#FFAE11] text-base font-bold text-[#FFFFFF] transition duration-300 hover:bg-[#EB8800]'
            onClick={() => router.refresh()}
          >
            {errorLocalization.reload}
          </Button>
        </Container>
      </Container>
    </div>
  );
}
